<ng-container *ngIf="filtersForm">
  <div class="filter-pan">
    <div class="filter-pan--header">
      <button mat-raised-button type="button" (click)="close()">Fermer</button>
    </div>
    <div class="filter-pan--content">
      <form [formGroup]="filtersForm">
        <div class="filter-pan--content--line">
          <mat-button-toggle-group formControlName="categorieCours" aria-label="Catégorie de cours">
            <mat-button-toggle [value]="1">{{filtersForm.controls['typeCours'].value === typeCours.stage? 'Intensif EC':'EC libre'}}</mat-button-toggle>
            <mat-button-toggle [value]="2">Loisir</mat-button-toggle>
            <mat-button-toggle [value]="3">Les deux</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div class="filter-pan--content--line">
          <mat-button-toggle-group formControlName="typeCours" aria-label="Type de cours">
            <mat-button-toggle [value]="1">Cours</mat-button-toggle>
            <mat-button-toggle [value]="2">Stage</mat-button-toggle>
            <mat-button-toggle [value]="0">Les deux</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div class="filter-pan--content--line">
          <mat-form-field appearance="outline">
            <mat-label>Jours</mat-label>
            <mat-select formControlName="jours" multiple>
              <mat-option [ngClass]="className" *ngFor="let jour of activityDays" [value]="jour.id">{{jour.label}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="filter-pan--content--line">
          <mat-form-field appearance="outline">
            <mat-label>Activités</mat-label>
            <mat-select formControlName="activites" multiple>
              <mat-option [ngClass]="className" *ngFor="let activite of activites" [value]="activite.id">{{activite.libelle}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </form>
    </div>
    <div class="filter-pan--footer">
      <button mat-raised-button type="button" (click)="clearFilters()">Effacer</button>
      <button mat-raised-button type="button" (click)="sendSearch()">Rechercher</button>
    </div>
  </div>
</ng-container>



